import React from "react";


function About() {
    return (
        <>
            <section className="page-section bg-primary" id="about">
                <div className="container px-4 px-lg-5">
                    <div className="row gx-4 gx-lg-5 justify-content-center">
                        <div className="col-lg-8 text-center">
                            <h2 className="text-white mt-0">Kimim ben </h2>
                            <hr className="divider divider-light"/>
                            <p className="text-white-75 mb-4">

                                <div style={{lineHeight: "1.4", marginBottom: "1.5rem"}}>
  <span style={{fontWeight: "700", fontSize: "1.2rem"}}>
    Ankara Yıldırım Beyazıt Üniversitesi
  </span>
                                    <br/>
                                    <span style={{fontWeight: "400", fontSize: "1rem"}}>
    Bilgisayar Mühendisliği Doktora
  </span>
                                    <br/>
                                    <span style={{fontWeight: "300", fontSize: "0.85rem", color: "#555"}}>
    Temmuz 2022 - Devam ediyor
  </span>
                                </div>

                                <div style={{lineHeight: "1.4" , marginBottom: "1.5rem"}}>
  <span style={{fontWeight: "700", fontSize: "1.2rem"}}>
    Ankara Yıldırım Beyazıt Üniversitesi
  </span>
                                    <br/>
                                    <span style={{fontWeight: "400", fontSize: "1rem"}}>
    Bilgisayar Mühendisliği Yüksek Lisans
  </span>
                                    <br/>
                                    <span style={{fontWeight: "300", fontSize: "0.85rem", color: "#555"}}>
    Şubat 2018 - Mart 2022
  </span>
                                </div>

                                <div style={{lineHeight: "1.4" , marginBottom: "1.5rem"}}>
  <span style={{fontWeight: "700", fontSize: "1.2rem"}}>
    Ahmet Yesevi Üniversitesi
  </span>
                                    <br/>
                                    <span style={{fontWeight: "400", fontSize: "1rem"}}>
    Bilgisayar Mühendisliği
  </span>
                                    <br/>
                                    <span style={{fontWeight: "300", fontSize: "0.85rem", color: "#555"}}>
    Eylül 2013 - Haziran 2016
  </span>
                                </div>
                                <div style={{lineHeight: "1.4", marginBottom: "1.5rem"}}>
  <span style={{fontWeight: "700", fontSize: "1.2rem"}}>
    Hacettepe Üniversitesi
  </span>
                                    <br/>
                                    <span style={{fontWeight: "400", fontSize: "1rem"}}>
    Bilgisayar ve Öğretim Teknolojileri Eğitimi Bölümü
  </span>
                                    <br/>
                                    <span style={{fontWeight: "300", fontSize: "0.85rem", color: "#555"}}>
    Eylül 2002 - Haziran 2006
  </span>
                                </div>


                            </p>
                            <a className="btn btn-light btn-xl" href="#certificates">Devam edelim !</a>
                        </div>
                    </div>
                </div>

            </section>
        </>
    );
}

export default About;